/**
 * 支付结算接口
 */
export default {
  // 支付结算管理-支付中心-商户管理
  pay_queryMerchant: {
    // mock: true,
    control: 'dyc/fsc/queryMerchant'
  },
  // 支付结算管理-支付中心-商户管理 详情接口
  pay_qryFscMerchantNewDetail: {
    // mock: true,
    control: 'dyc/fsc/qryFscMerchantNewDetail'
  },
  // 支付结算管理-支付中心-商户管理 详情接口
  pay_qrySaleOrderPayType: {
    // mock: true,
    control: 'dyc/fsc/qrySaleOrderPayType'
  },
  // 支付结算管理-支付中心-商户管理 新增接口
  pay_addFscMerchantNew: {
    // mock: true,
    control: 'dyc/fsc/addFscMerchantNew'
  },
  // 支付结算管理-支付中心-商户管理-商户新增/暂存
  pay_dealMerchantCreate: {
    // mock: true,
    control: 'dyc/fsc/dealMerchantCreate'
  },
  // 支付结算管理-支付中心-商户管理 修改接口
  pay_updateFscMerchantNew: {
    // mock: true,
    control: 'dyc/fsc/updateFscMerchantNew'
  },
  // 支付结算管理-支付中心-商户管理-商户删除
  pay_deleteMerchant: {
    // mock: true,
    control: 'dyc/fsc/deleteMerchant'
  },
  // 支付结算管理-支付中心-商户管理-商户新增页面-商户收款账户渠道信息-收款账户信息
  pay_queryPayee: {
    // mock: true,
    control: 'dyc/fsc/queryPayee'
  },
  // 支付结算管理-支付中心-商户管理-商户新增页面-商户基本信息查询
  pay_qryMerchantDetail: {
    // mock: true,
    control: 'dyc/fsc/qryMerchantDetail'
  },
  // 支付结算管理-支付中心-商户管理-商户新增页面-商户收款账户渠道信息暂存
  pay_dealPayeeEdit: {
    // mock: true,
    control: 'dyc/fsc/dealPayeeEdit'
  },
  // 支付结算管理-支付中心-商户管理-商户新增页面-例外情况-添加支付配置例外-提交
  pay_editException: {
    // mock: true,
    control: 'dyc/fsc/editException'
  },
  // 支付结算管理-支付中心-商户管理-商户修改页面-提交
  pay_editMerchant: {
    // mock: true,
    control: 'dyc/fsc/editMerchant'
  },
  // 支付结算管理-支付中心-商户管理-商户新增页面-商户收款账户渠道信息-支付渠道列表
  pay_queryPayChannel: {
    // mock: true,
    control: 'dyc/fsc/queryPayChannel'
  },
  // 支付结算管理-支付中心-商户管理-商户新增页面-文件上传
  pay_uploadFile: {
    // mock: true,
    control: 'dyc/fsc/payCenter/uploadFile'
  },
  // 支付结算管理-支付中心-商户管理-例外情况-添加结算模式配置例外页面-选择商品类型
  pay_queryCommodityType: {
    // mock: true,
    control: 'dyc/fsc/queryCommodityType'
  },
  // 支付结算管理-支付中心-商户管理-例外情况-添加结算模式配置例外页面-选择合同
  pay_queryEnterContractList: {
    // mock: true,
    control: 'dyc/contract/queryEnterContractList'
  },
  // 支付结算管理-支付中心-商户管理-例外情况-添加结算模式配置例外页面-选择签约申请
  pay_getSupSignContractList: {
    // mock: true,
    control: 'dyc/supplier/signContract/getSupSignContractList'
  },
  // 支付结算管理-支付中心-商户管理-商户新增页面-例外情况-添加例外支付情况-修改支付渠道下拉列表
  pay_qryRelChannel: {
    // mock: true,
    control: 'dyc/fsc/qryRelChannel'
  },
  // 支付结算管理-支付中心-基础配置管理-支付机构名称下拉列表
  pay_queryPaymentIns: {
    // mock: true,
    control: 'dyc/fsc/queryPaymentIns'
  },
  // 支付结算管理-支付中心-基础配置管理-支付机构配置列表查询
  pay_qryPagePaymentIns: {
    // mock: true,
    control: 'dyc/fsc/qryPagePaymentIns'
  },
  // 支付结算管理-支付中心-基础配置管理-收银台基础配置列表查询
  pay_queryCashier: {
    // mock: true,
    control: 'dyc/fsc/queryCashier'
  },
  // 支付结算管理-支付中心-基础配置管理-收银台基本信息编辑
  pay_editCashierBaseInfo: {
    // mock: true,
    control: 'dyc/fsc/editCashierBaseInfo'
  },
  // 支付结算管理-支付中心-基础配置管理-收银台支付方式编辑
  pay_editCashierPayMethod: {
    // mock: true,
    control: 'dyc/fsc/editCashierPayMethod'
  },
  // 支付结算管理-支付中心-基础配置管理-收银台详情查询
  pay_queryCashierDetail: {
    // mock: true,
    control: 'dyc/fsc/queryCashierDetail'
  },
  // 支付结算管理-支付中心-基础配置管理-支付机构详情查询
  pay_queryPaymentDetail: {
    // mock: true,
    control: 'dyc/fsc/queryPaymentDetail'
  },
  // 支付结算管理-支付中心-基础配置管理-支付机构图标管理-提交
  pay_editPayMethodIcon: {
    // mock: true,
    control: 'dyc/fsc/editPayMethodIcon'
  },
  // 公共应用-结算商户配置查询API
  pay_queryMerchantConfig: {
    // mock: true,
    control: 'dyc/fsc/queryMerchantConfig'
  },
  // 公共应用-结算单金额限制查询
  pay_qryOrderSplitConditonDetail: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryOrderSplitConditonDetail'
  },
  // 公共应用-结算单配置中心
  pay_qryReconciliationChannelListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryReconciliationChannelListPage'
  },
  // 支付结算 付款主单创建API
  pay_dealDycPayBillCreate: {
    // mock: true,
    control: 'dyc/fsc/dealDycPayBillCreate'
  },
  // 支付结算管理-支付中心-商户管理-商户新增页面-商户基本信息-企业机构下拉列表
  pay_queryEnterpriseOrgTree: {
    // mock: true,
    control: 'dyc/saas/common/user/org/queryEnterpriseOrgTree'
  },
  // 我的首页-发票及账套信息-公共应用-发票邮寄地址启停/删除API
  pay_operInvoiceAddress: {
    // mock: true,
    control: 'dyc/common/user/invoiceAddress/operInvoiceAddress'
  },
  // 我的首页-发票及账套信息-公共应用-支付确认API
  pay_dealDycPayConfirm: {
    // mock: true,
    control: 'dyc/fsc/dealDycPayConfirm'
  },
  // 我的首页-发票及账套信息-公共应用-支付确认API
  pay_dealDownPayConfirm: {
    // mock: true,
    control: 'dyc/fsc/dealDownPayConfirm'
  },
  // 查看付款凭证
  pay_qryNewAttachment: {
    // mock: true,
    control: 'dyc/fsc/qryNewAttachment'
  },
  // 我的首页-发票及账套信息-公共应用-待付款确认API
  pay_dealDycPayConfirmForServicePay: {
    // mock: true,
    control: 'dyc/fsc/dealDycPayConfirmForServicePay'
  },
  // 我的首页-发票及账套信息-公共应用-公用应用-发票邮寄地址修改服务
  pay_updateInvoiceAddress: {
    // mock: true,
    control: 'dyc/saas/common/user/upadteInvoiceAddress'
  },
  // 我的首页-发票及账套信息-公共应用-公共应用-开票主单开票申请API
  pay_dealInvoiceApply: {
    // mock: true,
    control: 'dyc/fsc/dealInvoiceApply'
  },
  // 我的首页-发票及账套信息-公共应用-公用应用-发票邮寄地址新增服务
  pay_addInvoiceAddress: {
    // mock: true,
    control: 'dyc/saas/common/user/addInvoiceAddress'
  },
  // 我的首页-发票及账套信息-公共应用-公用应用-发票邮寄地址详情查询服务
  pay_qryInvoiceAddressDetail: {
    // mock: true,
    control: 'dyc/saas/common/user/qryInvoiceAddressDetail'
  },
  // 我的首页-发票及账套信息-公共应用-企业发票信息列表分页查询API
  pay_qryAccountInvoiceListPage: {
    // mock: true,
    control: 'dyc/saas/common/qryAccountInvoiceListPage'
  },
  // 支付结算（运营单位）-1menu支付结算管理-2menu收付款管理-3menu付款申请-应付记录列表查询API
  pay_qryShouldPayList: {
    // mock: true,
    control: 'dyc/fsc/qryShouldPayList'
  },
  // 支付结算
  pay_qryPayBillList: {
    // mock: true,
    control: 'dyc/fsc/qryPayBillList'
  },
  // 我的首页-发票及账套信息-公共应用-企业账套列表翻页查询
  pay_qryEnterpriseAccountListPage: {
    // mock: true,
    control: 'dyc/saas/common/user/qryEnterpriseAccountListPage'
  },
  // 我的首页-发票及账套信息-公共应用-企业账套列表审批
  pay_qryWaitAuditEnterpriseAccountListPage: {
    // mock: true,
    control: 'dyc/common/user/account/qryWaitAuditEnterpriseAccountListPage'
  },
  // 我的首页-发票及账套信息-公共应用-企业供应商下拉列表
  pay_qryDropDwonList: {
    // mock: true,
    control: 'dyc/saas/common/user/enterprise/qryDropDwonList'
  },
  // 我的首页-发票及账套信息-公共应用-企业账套停/启用API
  pay_changeEnterpriseAccountState: {
    // mock: true,
    control: 'dyc/common/user/account/changeEnterpriseAccountState'
  },
  // 我的首页-发票及账套信息-公共应用-企业账套删除API
  pay_deleteEnterpriseAccount: {
    // mock: true,
    control: 'dyc/common/user/account/deleteEnterpriseAccount'
  },
  // 我的首页-发票及账套信息-公用应用-省份字典列表
  pay_queryProvinceList: {
    // mock: true,
    control: 'dyc/common/user/noauth/province/queryProvinceList'
  },
  // 查询上级机构下账套信息
  pay_queryOrgUpAccount: {
    // mock: true,
    control: 'dyc/common/user/queryOrgUpAccount'
  },
  // 我的首页-发票及账套信息-公用应用-运营单位下拉列表
  pay_qryOperateDropDwonList: {
    // mock: true,
    control: 'dyc/common/user/org/qryOperateDropDwonList'
  },
  // 我的首页-发票及账套信息-公用应用-运营单位下拉列表
  pay_qryProfessionalList: {
    // mock: true,
    control: '/dyc/common/user/org/qryProfessionalList'
  },
  // 我的首页-发票及账套信息-公用应用-所属组织机构下拉树查询
  pay_queryUserIsProfessionalOrgOrgTree: {
    // mock: true,
    control: 'dyc/common/user/org/queryUserIsProfessionalOrgOrgTree'
  },
  // 我的首页-发票及账套信息-公用应用-企业账套新增API
  pay_addEnterpriseAccount: {
    // mock: true,
    control: 'dyc/common/user/account/addEnterpriseAccount'
  },
  // 我的首页-发票及账套信息-公用应用-企业账套详情查询
  pay_qryEnterpriseAccountDetail: {
    // mock: true,
    control: 'dyc/common/user/account/qryEnterpriseAccountDetail'
  },
  // 我的首页-发票及账套信息-公用应用-企业账套修改API
  pay_updateEnterpriseAccount: {
    // mock: true,
    control: 'dyc/common/user/account/updateEnterpriseAccount'
  },
  // 我的首页-发票及账套信息-公用应用-采购单位下拉列表
  pay_dealServiceFeeInvoiceUpload: {
    // mock: true,
    // control: 'dyc/saas/common/user/org/qryPurchaseDropDwonList'
    control: 'dyc/fsc/dealServiceFeeInvoiceUpload'
  },
  // 我的首页-发票及账套信息-公用应用-采购单位下拉列表
  pay_qryPurchaseDropDwonList: {
    // mock: true,
    // control: 'dyc/saas/common/user/org/qryPurchaseDropDwonList'
    control: 'dyc/common/user/org/qryPurchaseIncludeDeptDropDwonList'
  },
  // 我的首页-发票及账套信息-公共应用-企业发票设置默认API
  pay_setDefaultEnterpriseInvoce: {
    // mock: true,
    control: 'dyc/common/user/account/setDefaultEnterpriseInvoce'
  },
  // 我的首页-发票及账套信息-公共应用-企业发票信息删除API
  pay_operAccountInvoice: {
    // mock: true,
    control: 'dyc/common/user/accountInvoice/operAccountInvoice'
  },
  // 支付结算管理-公共应用-订单关联结算列表查询
  pay_getOrderListQryForFsc: {
    // mock: true,
    control: 'dyc/fsc/getOrderListQryForFsc'
  },
  // 支付结算管理-公共应用-成交服务费带形成单据、详情页列表查询
  pay_queryTransactionServiceList: {
    // mock: true,
    control: 'dyc/fsc/queryTransactionServiceList'
  },
  // 支付结算管理-公共应用-服务费列表查询API
  pay_qryServiceList: {
    // mock: true,
    control: 'dyc/fsc/qryServiceList'
  },
  // 支付结算-付款申请单审批列表查询
  pay_qryPayBillApprovalList: {
    // mock: true,
    control: 'dyc/fsc/qryPayBillApprovalList'
  },
  // 支付结算管理-公共应用-服务费列表查询API
  pay_qryOrderList: {
    // mock: true,
    control: 'dyc/fsc/qryOrderList'
  },
  // 支付结算管理-公共应用-主单确认API
  dyc_dealOrderConfirm: {
    // mock: true,
    control: 'dyc/fsc/dealOrderConfirm'
  },
  // 支付结算管理-公共应用-服务费主单申请开票API
  pay_dealPayInvoiceApply: {
    // mock: true,
    control: 'dyc/fsc/dealPayInvoiceApply'
  },
  // 我的首页-发票及账套信息-公共应用-企业发票信息修改API
  pay_updateAccountInvoice: {
    // mock: true,
    control: 'dyc/common/user/accountInvoice/updateAccountInvoice'
  },
  // 我的首页-发票及账套信息-公共应用-企业发票信息修改API
  pay_qryInvoiceAddressListPage: {
    // mock: true,
    control: 'dyc/saas/common/user/qryInvoiceAddressListPage'
  },
  // 我的首页-发票及账套信息-公共应用-企业发票信息详情查询API
  pay_qryAccountInvoiceDetail: {
    // mock: true,
    control: 'dyc/common/user/accountInvoice/qryAccountInvoiceDetail'
  },
  // 我的首页-发票及账套信息-公共应用-企业账套信息审核API
  pay_dealAccountAudit: {
    // mock: true,
    control: 'dyc/common/user/account/dealAccountAudit'
  },
  // 我的首页-发票及账套信息-公共应用-企业发票信息新增API
  pay_addAccountInvoice: {
    // mock: true,
    control: 'dyc/common/user/accountInvoice/addAccountInvoice'
  },
  // 我的首页-发票及账套信息-公共应用-查询是否有专票
  pay_qrySpecialInvoice: {
    // mock: true,
    control: 'dyc/common/user/accountInvoice/qrySpecialInvoice'
  },
  // 支付结算管理-支付中心-商户管理-商户新增页面-商户收款账户渠道信息-添加支付渠道-支付渠道下拉框
  pay_qryPayMethodAndParas: {
    // mock: true,
    control: 'dyc/fsc/qryPayMethodAndParas'
  },
  // 支付结算管理-发起结算单-拆分限制
  pay_qryOrderSplitConditonListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryOrderSplitConditonListPage'
  },
  // 支付结算管理-供应商-对账结果导入-供应商可结算数量小数限制
  pay_getmeasureInfo: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/getmeasureInfo'
  },
  // 支付结算管理-支付结算-账户管理-查询
  dyc_queryAccountList: {
    // mock: true,
    control: 'dyc/fsc/queryAccountList'
  },
  // 支付结算管理-支付结算-账户管理-新增
  dyc_createAccount: {
    // mock: true,
    control: 'dyc/fsc/createAccount'
  },
  // 支付结算管理-支付结算-账户管理-号码获取
  dyc_createAccountNo: {
    // mock: true,
    control: 'dyc/fsc/createAccountNo'
  },
  // 支付结算管理-支付结算-账户管理-详情
  dyc_queryAccountDetail: {
    // mock: true,
    control: 'dyc/fsc/queryAccountDetail'
  },
  // 支付结算管理-支付结算-账户管理-交易明细
  dyc_qryAccountPayDetailList: {
    // mock: true,
    control: 'dyc/fsc/qryAccountPayDetailList'
  },
  // 支付结算管理-支付结算-账户管理-授信情况
  dyc_qryAccountCreditInfoList: {
    // mock: true,
    control: 'dyc/fsc/qryAccountCreditInfoList'
  },
  // 支付结算管理-支付结算-上游协议对账-业务对账
  dyc_getOrderListQryForFsc: {
    // mock: true,
    control: 'dyc/fsc/getOrderListQryForFsc'
  },
  // 支付结算管理-支付结算-上游协议对账-业务对账
  dyc_dealPayServiceOrdCreate: {
    // mock: true,
    control: 'dyc/fsc/dealPayServiceOrdCreate'
  },
  // 支付结算管理-公共应用-服务费支付API
  dyc_dealPayServiceBillCreateAndPay: {
    // mock: true,
    control: 'dyc/fsc/dealPayServiceBillCreateAndPay'
  },
  // 支付结算管理-支付结算-上游协议对账-业务对账-开票主单打捆校验API
  dyc_dealBundlCheck: {
    // mock: true,
    control: 'dyc/fsc/dealBundlCheck'
  },
  // 支付结算管理-支付结算-上游协议对账-业务对账-运营单位是否允许代采购单位发起下游结算单列表API
  dyc_qryAgentPurDownSettleListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryAgentPurDownSettleListPage'
  },
  // 支付结算管理-支付结算-上游协议对账-业务对账-挂起
  dyc_dealRelUpdate: {
    // mock: true,
    control: 'dyc/fsc/dealRelUpdate'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单确认-发票信息
  dyc_qryAccountInvoiceListPage: {
    // mock: true,
    control: 'dyc/saas/common/qryAccountInvoiceListPage'
  },
  // 支付结算管理-支付结算-电商对账
  dyc_dealEcomCheckApply: {
    // mock: true,
    control: 'dyc/fsc/dealEcomCheckApply'
  },
  // 支付结算管理-支付结算-电商对账
  dyc_dealEcomCheck: {
    // mock: true,
    control: 'dyc/fsc/dealEcomCheck'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单确认-地址
  dyc_qryInvoiceAddressListPage: {
    // mock: true,
    control: 'dyc/saas/common/user/qryInvoiceAddressListPage'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单确认-拆分
  dyc_getSplitCompute: {
    // mock: true,
    control: 'dyc/fsc/getSplitCompute'
  },
  // 支付结算管理-支付结算- 查询应收金额
  dyc_qrySaleTemporaryContract: {
    // mock: true,
    control: 'dyc/saas/self/order/qrySaleTemporaryContract'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单确认-提价
  dyc_dealCreate: {
    // mock: true,
    control: 'dyc/fsc/dealCreate'
  },
  // 支付结算管理-支付结算-上游协议对账-业务对账-结算单
  dyc_qryOrderList: {
    // mock: true,
    control: 'dyc/fsc/qryOrderList'
  },
  // 支付结算管理-支付结算-上游协议对账-业务对账-取消结算单
  dyc_dealOrderCancel: {
    // mock: true,
    control: 'dyc/fsc/dealOrderCancel'
  },
  // 支付结算管理-支付结算-下游协议对账-业务对账-开票主单反馈API
  dyc_dealOrderFeedback: {
    // mock: true,
    control: 'dyc/fsc/dealOrderFeedback'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单-发票签收
  dyc_dealOrderInvoiceCheck: {
    // mock: true,
    control: 'dyc/fsc/dealOrderInvoiceCheck'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单-签收
  dyc_dealOrderInvoiceSign: {
    // mock: true,
    control: 'dyc/fsc/dealOrderInvoiceSign'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单-发票下载
  dyc_qryInvoiceList: {
    // mock: true,
    control: 'dyc/fsc/qryInvoiceList'
  },
  // 支付结算管理-支付结算-开票主单获取电商发票API
  dyc_getInvoiceData: {
    // mock: true,
    control: 'dyc/fsc/getInvoiceData'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单-导入对账数据
  dyc_supplierCheckImport: {
    // mock: true,
    control: 'dyc/fsc/supplierCheckImport'
  },
  // 支付结算管理-支付结算-供应商-协议结算对账-确认对账
  dyc_dealSupplierCheck: {
    // mock: true,
    control: 'dyc/fsc/dealSupplierCheck'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单-详情
  dyc_qryOrderDetail: {
    // mock: true,
    control: 'dyc/fsc/qryOrderDetail'
  },
  // 支付结算管理-支付结算-公共应用-开票主单邮寄信息录入API
  dyc_dealMailEntry: {
    // mock: true,
    control: 'dyc/fsc/dealMailEntry'
  },
  // 支付结算管理-支付结算-公共应用-是否对接
  dyc_qryExtSystemListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryExtSystemListPage'
  },
  // 支付结算 - 主单审批Api
  pay_dealOrderApproval: {
    // mock: true,
    control: 'dyc/fsc/dealOrderApproval'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单-确认对账
  dyc_dealSupCheckConfirm: {
    // mock: true,
    control: 'dyc/fsc/dealSupCheckConfirm'
  },
  // 支付结算管理-支付结算-上游协议对账-结算单-详情-发票明细
  dyc_qryInvoiceItemList: {
    // mock: true,
    control: 'dyc/fsc/qryInvoiceItemList'
  },
  // 支付结算管理-支付结算-供应商协议对账-结算单-详情-发票导入查询
  dyc_queryInvoiceRule: {
    // mock: true,
    control: 'dyc/fsc/queryInvoiceRule'
  },
  // 支付结算管理-支付结算-供应商协议对账-结算单-详情-提交
  dyc_dealDycInvoiceUpload: {
    // mock: true,
    control: 'dyc/fsc/dealDycInvoiceUpload'
  },
  // 支付结算管理-支付结算-供应商协议对账-结算单-详情-提交(运费)
  dyc_dealTransFeeInvoiceUpload: {
    // mock: true,
    control: 'dyc/fsc/dealTransFeeInvoiceUpload'
  },
  // 上传模板下载
  dyc_exportInvoiceForOrderExcel: {
    // mock: true,
    control: 'dyc/fsc/exportInvoiceForOrderExcel'
  },
  // 上传模板下载（运费）
  dyc_dealInvoiceForTransFeeExcelExport: {
    // mock: true,
    control: 'dyc/fsc/dealInvoiceForTransFeeExcelExport'
  },
  // 上传发票-下载模板
  dyc_exportInvoiceServiceFeeExcel: {
    // mock: true,
    control: 'dyc/fsc/exportInvoiceServiceFeeExcel'
  },
  // 支付结算管理-支付结算-供应商协议对账-结算单-详情-提交
  dyc_qryOrderDetailMountListPage: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryOrderDetailMountListPage'
  },
  // 支付结算管理-支付中心-商户管理-商户新增页面-商户收款账户渠道信息-添加支付渠道-提交
  pay_editPayChannel: {
    // mock: true,
    control: 'dyc/fsc/editPayChannel'
  },
  // 支付结算管理-付款管理-确认付款页面-提交
  dyc_dealDycPayBill: {
    // mock: true,
    control: 'dyc/fsc/dealDycPayBill'
  },
  // 支付结算管理-付款管理-修改页面-提交
  dyc_dealPayBillUpdate: {
    // mock: true,
    control: 'dyc/fsc/dealPayBillUpdate'
  },
  // 公用应用-结算审批流程列表查询API
  dyc_getFscApprovalprocessListQry: {
    // mock: true,
    // control: 'dyc/fsc/getFscApprovalprocessListQry'
    control: 'dyc/saas/audit/queryOperationRecordsList'
  },
  // 支付结算-支付结算管理-发票邮寄-查询
  dyc_qryMailList: {
    // mock: true,
    control: 'dyc/fsc/qryMailList'
  },
  // 支付结算-支付结算管理-发票邮寄-发起邮寄
  dyc_dealMailOper: {
    // mock: true,
    control: 'dyc/fsc/dealMailOper'
  },
  // 支付结算-支付结算管理-库存管理
  dyc_qryStockItemList: {
    // mock: true,
    control: 'dyc/fsc/qryStockItemList'
  },
  // 支付结算-支付结算管理-在线支付系统对账
  dyc_qryPayCheckList: {
    // mock: true,
    control: 'dyc/fsc/qryPayCheckList'
  },
  // 支付结算-支付结算管理-在线支付系统对账
  dyc_qryStockList: {
    // mock: true,
    control: 'dyc/fsc/qryStockList'
  },
  // 公共应用-根据库存明细查询出入库单列表API
  dyc_qryStockListByItemId: {
    // mock: true,
    control: 'dyc/fsc/qryStockListByItemId'
  },
  // 公共应用-根据库存明细查询出入库单列表API
  dyc_dealDycPayConfirm: {
    // mock: true,
    control: 'dyc/fsc/dealDycPayConfirm'
  },
  // 公用应用-结算审批流程节点查询API
  dyc_getFscProcNodeQry: {
    // mock: true,
    control: 'dyc/fsc/getFscProcNodeQry'
  },
  // 公用应用-结算审批流程节点查询API
  dyc_queryProcessResourceFile: {
    // mock: true,
    control: 'osworkflow/conf/process/queryProcessResourceFile'
  },
  // 公共应用- 在线支付交易记录查询API
  pay_qryPayRecordList: {
    // mock: true,
    control: 'dyc/fsc/qryPayRecordList'
  },
  // 公共应用- 在线支付交易记录查询API
  pay_qryOrgList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryOrgList'
  },
  // 支付结算参数--供应商列表
  pay_listAllSuppliers: {
    // mock: true,
    control: 'dyc/saas/supplier/qrySupplierInfoAccessListPage'
  },
  // 公共应用-根据库存明细查询出入库单列表API
  dyc_pay_dealDycPayConfirm: {
    // mock: true,
    control: 'metaData/dyc/fsc/pay/dealDycPayConfirm'
  },
  // 查询发票列表
  shopMall_getInvoice: {
    // mock: true,
    control: 'dyc/common/user/getInvoice'
  },
  // 支付结算管理-支付中心-商户管理 列表接口
  pay_qryFscMerchantNewList: {
    // mock: true,
    control: 'dyc/fsc/qryFscMerchantNewList'
  },
  // 支付结算管理-支付中心-商户管理 删除接口
  pay_deleteFscMerchantNew: {
    // mock: true,
    control: 'dyc/fsc/deleteFscMerchantNew'
  },
  // 查询物流信息
  dyc_qryEcomInvoicePost: {
    // mock: true,
    control: 'dyc/fsc/qryEcomInvoicePost'
  },
  // 获取快递公司列表
  dyc_queryLogisticCompanyLikely: {
    // mock: true,
    control: 'dyc/sassnogateway/saas/common/queryLogisticCompanyLikely'
  },
  // 采购方确认对账结果接口
  dyc_dealPurCheckConfirm: {
    // mock: true,
    control: 'dyc/fsc/dealPurCheckConfirm'
  },
  // 采购单位
  dyc_qryOrgListPageByOrgTag: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/qryOrgListPageByOrgTag'
  },
  // 采购单位
  dyc_qryOrderTrack: {
    // mock: true,
    control: 'dyc/self/order/qryOrderTrackOld'
  },
  // 查询进度
  dyc_checkPaymentProgress: {
    // mock: true,
    control: 'dyc/fsc/checkPaymentProgress'
  },
  // 上传模板下载
  dyc_exportInvoiceServiceFeeExcelNew: {
    // mock: true,
    control: 'dyc/fsc/exportInvoiceServiceFeeExcel'
  },
  // 上传模板下载
  dyc_qryTaskInfo: {
    // mock: true,
    control: '	dyc/fsc/qryTaskInfo'
  },
  // 商户模板下载
  dyc_dealPurchaserMerchantExportTemplate: {
    // mock: true,
    control: 'dyc/fsc/dealPurchaserMerchantExportTemplate'
  },
  // 商户模板导入
  dyc_dealPurchaserMerchantImportTemplate: {
    // mock: true,
    control: 'dyc/fsc/dealPurchaserMerchantImportTemplate'
  },
  // 商户机构
  dyc_qrySupDropDownPageList: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/qrySupDropDownPageList'
  },
  // 发票信息新增
  dyc_createInvoiceInfo: {
    // mock: true,
    control: 'dyc/saas/common/user/createInvoiceInfo'
  },
  // 发票信息修改
  dyc_updateInvoiceInfo: {
    // mock: true,
    control: 'dyc/saas/common/user/updateInvoiceInfo'
  },
  // 运费金额
  dyc_qryFscTransFee: {
    // mock: true,
    control: 'dyc/fsc/qryFscTransFee'
  },
  // 多选导出
  dyc_dealOrderDetailExcelExport: {
    // mock: true,
    control: 'dyc/fsc/dealOrderDetailExcelExport'
  },
  // 根据供应商ID查询
  dyc_qryCreateSaleOrderCheckMerchant: {
    // mock: true,
    control: 'dyc/fsc/qryCreateSaleOrderCheckMerchant'
  },
  // 判断内外部
  dyc_qryOrgBaseInfoDetail: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/qryOrgBaseInfoDetail'
  },
  // 获取支付信息
  dyc_queryCashierDesk: {
    // mock: true,
    control: 'pay/rest/cashierDesk/queryCashierDesk'
  },
  // 易宝
  dyc_payProDealOrder: {
    // mock: true,
    control: 'pay/rest/payPro/dealOrder'
  },
  // 沃支付
  dyc_worestPayProDealOrder: {
    // mock: true,
    control: 'pay/worest/payPro/dealOrder'
  },
  // 线下支付信息
  dyc_qryCashierDownPayItem: {
    // mock: true,
    control: 'dyc/fsc/noauth/qryCashierDownPayItem'
  },
  // 线下支付提交
  dyc_dealCashierDownPayItem: {
    // mock: true,
    control: 'dyc/fsc/noauth/dealCashierDownPayItem'
  },
  // 获取线下支付（另外三个）
  dyc_qryOrderListCashierDownPayItem: {
    // mock: true,
    control: 'dyc/fsc/qryOrderListCashierDownPayItem'
  },
  // 上游验收单维度多选导出
  dyc_dealOrderDetailUpExcelExport: {
    // mock: true,
    control: 'dyc/fsc/dealOrderDetailUpExcelExport'
  },
  // 上游应收维度多选导出
  dyc_dealOrderDetailUpNeedPayExcelExport: {
    // mock: true,
    control: 'dyc/fsc/dealOrderDetailUpNeedPayExcelExport'
  },
  // 新增发票
  dyc_createOperateInvoiceInfo: {
    // mock: true,
    control: 'dyc/saas/common/user/createOperateInvoiceInfo'
  },
  // 修改发票
  dyc_updateOperateInvoiceInfo: {
    // mock: true,
    control: 'dyc/saas/common/user/updateOperateInvoiceInfo'
  },
  // 应付台账
  dyc_qryFscNeedPayList: {
    // mock: true,
    control: 'dyc/fsc/qryFscNeedPayList'
  },
  // 应付台账-详情
  dyc_qryFscNeedPayDetail: {
    // mock: true,
    control: 'dyc/fsc/qryFscNeedPayDetail'
  },
  // 应付台账-查询发票信息
  dyc_qryExtSystemsInvoiceList: {
    // mock: true,
    control: 'dyc/fsc/qryExtSystemsInvoiceList'
  },
  // 应付台账-添加发票
  dyc_addFscNeedPayInvoiceList: {
    // mock: true,
    control: 'dyc/fsc/addFscNeedPayInvoiceList'
  },
  // 应付台账-删除发票
  dyc_delFscNeedPayInvoice: {
    // mock: true,
    control: 'dyc/fsc/delFscNeedPayInvoice'
  },
  // 应付台账-详情-关联实付台账列表
  dyc_qryRelateRelPayInfoListByPage: {
    // mock: true,
    control: 'dyc/fsc/qryRelateRelPayInfoListByPage'
  },
  // 应付台账-详情-获取实付
  dyc_getNeedPayCallMoney: {
    // mock: true,
    control: 'dyc/saas/fsc/getNeedPayCallMoney'
  },
  // 应付台账-查询是否为合同下单
  dyc_checkContractOrder: {
    // mock: true,
    control: 'dyc/saas/order/checkContractOrder'
  },
  // 协议上游对账单推送成本系统
  dyc_dealBySelfCallFscNotContractUp: {
    // mock: true,
    control: 'dyc/fsc/dealBySelfCallFscNotContractUp'
  },
  // 下游-对账单-编辑对账单-批量移除对单单明细
  dyc_qryCheckAfterFscOrder: {
    // mock: true,
    control: 'dyc/fsc/qryCheckAfterFscOrder'
  },
  // 下游-对账单-编辑对账单-确认
  dyc_dealNotCheckFscOrder: {
    // mock: true,
    control: 'dyc/fsc/dealNotCheckFscOrder'
  },
  // 上游-应收维度-详情对账单明细列表
  dyc_qryNeedPayOrderRelationListByPage: {
    // mock: true,
    control: 'dyc/fsc/qryNeedPayOrderRelationListByPage'
  },
  // 应收台账列表
  dyc_qryReceivableListByPage: {
    // mock: true,
    control: 'dyc/fsc/qryReceivableListByPage'
  },
  // 应收台账详情
  dyc_qryReceivableDetail: {
    // mock: true,
    control: 'dyc/fsc/qryReceivableDetail'
  },
  // 应收台账详情-修改负责人
  dyc_updateReceivableUserName: {
    // mock: true,
    control: 'dyc/fsc/updateReceivableUserName'
  },
  // 实付台账列表
  dyc_qryRelPayInfoListByPage: {
    // mock: true,
    control: 'dyc/fsc/qryRelPayInfoListByPage'
  },
  // 实付台账详情
  dyc_qryRelPayInfo: {
    // mock: true,
    control: 'dyc/fsc/qryRelPayInfo'
  },
  // 实付台账详情-手工减免列表
  dyc_qryRelPayNeedRelationListByPage: {
    // mock: true,
    control: 'dyc/fsc/qryRelPayNeedRelationListByPage'
  },
  // 实付台账详情-手工减免确认
  dyc_updateRelPayNeedRelationList: {
    // mock: true,
    control: 'dyc/fsc/updateRelPayNeedRelationList'
  },
  // 实付台账详情-付款明细列表
  dyc_qryRelPayItemListByPage: {
    // mock: true,
    control: 'dyc/fsc/qryRelPayItemListByPage'
  },
  // 实付台账详情-发票明细列表
  dyc_qryRelPayInvoiceListByPage: {
    // mock: true,
    control: 'dyc/fsc/qryRelPayInvoiceListByPage'
  },
  // 实付台账详情-付款明细-添加明细弹窗表格
  dyc_qryRelFscNeedPayList: {
    // mock: true,
    control: 'dyc/fsc/qryRelFscNeedPayList'
  },
  // 实付台账详情-付款明细-添加明细
  dyc_addRelPayNeedRelationList: {
    // mock: true,
    control: 'dyc/fsc/addRelPayNeedRelationList'
  },
  // 实付台账详情-付款明细-删除明细
  dyc_delRelPayNeedRelation: {
    // mock: true,
    control: 'dyc/fsc/delRelPayNeedRelation'
  }
};